export class EducationJobTag {
    readonly id: number;
    readonly description: string;

    private constructor(id: number, description: string) {
        this.id = id;
        this.description = description;
    }

    public static HighSchoolOrEquivalent = new EducationJobTag(
        2692,
        "High School/GED"
    );
    public static Associate = new EducationJobTag(2693, "Associate");
    public static Bachelors = new EducationJobTag(2694, "Bachelor's");
    public static Masters = new EducationJobTag(2695, "Master's");
    public static Doctorate = new EducationJobTag(2696, "Doctorate");

    public static asArray = () => [
        EducationJobTag.HighSchoolOrEquivalent,
        EducationJobTag.Associate,
        EducationJobTag.Bachelors,
        EducationJobTag.Masters,
        EducationJobTag.Doctorate,
    ];

    public static fromId = (id: number) =>
        EducationJobTag.asArray().find(t => t.id === id);

    public static IsDoctorate = (id: number) =>
        EducationJobTag.Doctorate.id === id;
}
